import { _ } from "libs";

import React from "react";
import withRedux from "../../withRedux";
import { Profile } from "../../types";
import Modal from "../modal";
import { closePlayerPopup } from "../../actions";
import { formatName } from "../../libs/formatName";
import PlayerProfile from "../playerProfile";
import { RootState } from "../../reducers";

function PlayerModal({
	show = false,
	profile = null,
	isMyProfile = false,
	showChallengeButton = false,
	challengeButtonParams = {},
	contextParams = {},
}: {
	show: boolean;
	profile: Profile;
	isMyProfile: boolean;
	showChallengeButton: boolean;
	challengeButtonParams: object;
	contextParams: any;
}) {
	if (show === false) {
		return null;
	}

	const close = () => {
		closePlayerPopup();
	};

	if (profile === null) {
		return (
			<Modal title={_("error.playerNotFound")} onCloseClicked={close} onBackClicked={contextParams?.backAction}>
				{_("error.playerNotFound")}
			</Modal>
		);
	}

	return (
		<Modal
			title={formatName(profile.firstName, profile.lastName)}
			onCloseClicked={close}
			onBackClicked={contextParams?.backAction}
			fullHeight={true}
		>
			<PlayerProfile
				profile={profile}
				onClose={null}
				showHeader={false}
				isMyProfile={isMyProfile}
				showChallengeButton={showChallengeButton}
				challengeButtonParams={challengeButtonParams}
				contextParams={contextParams}
			/>
		</Modal>
	);
}

function mapStateToProps({
	playerModal: { show, selectedProfileId, profiles, showChallengeButton, challengeButtonParams, contextParams },
	profile: { userId },
}: RootState) {
	const isMyProfile = selectedProfileId === userId;

	let profile = null;
	if (selectedProfileId) {
		profile = profiles[selectedProfileId];
	}

	return { show, profile, isMyProfile, showChallengeButton, challengeButtonParams, contextParams };
}

export default withRedux({}, mapStateToProps)(PlayerModal);
